import CareReceiver, { CareReceiverData } from './CareReceiver'

export interface SelfBookerData extends CareReceiverData {
  customer_id: string
  email: string
  phone_number: string
  relationship: 'You' | 'Ich selbst'
}

class SelfBooker extends CareReceiver {
  customerId: string

  email: string

  phoneNumber: string

  constructor(props: SelfBookerData) {
    super(props)

    this.customerId = props.customer_id
    this.email = props.email
    this.phoneNumber = props.phone_number
  }
}

export default SelfBooker
